import React, { useState,useEffect } from 'react';
import { cuurentNextYear } from './Function';
import { Card,Row,Col,ListGroup,Placeholder, Button } from 'react-bootstrap';
const UndergraduateAdmission = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[programGroups,setGroups]=useState([]);
    const[isLoading, setLoading] = useState(true);
    useEffect(()=>
    {
        const getProgramGroup = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"programsGroup/all");
                const result = await response.json();
                setGroups(result);
                setLoading(false);
                if( global.config.IsPrint === true ) { console.info('Program Groups : Result',result); }
              
            } catch (error) 
            {
                console.error('Program Groups : Error', error.message);
            }
        };
        getProgramGroup();    
    },[])
    return (
        <React.Fragment>
        {isLoading ? (
            <React.Fragment>
            {[...Array(1)].map((_, index) => (
                <Card className=' mb-4' key={index}>
                    <Card.Header className='text-center fs-3'><Placeholder xs={6} /></Card.Header>
                    <Card.Body>
                    <Row className='g-3'>
                    {[...Array(3)].map((_, index) => (
                        <Col md="auto" key={index}>
                            <Card className='bg-success-subtle'>
                                <Card.Header className='text-bg-primary text-center fs-5'><Placeholder xs={6} /></Card.Header>
                                <Card.Body>
                                    <Row className='g-3'>
                                        {[...Array(10)].map((_, index) => (
                                        <Col md="auto" key={index}>
                                            <Card className=' text-center h-100'  style={{width:"13rem"}}>
                                                <Card.Header className='flex-grow-1 d-flex align-items-center justify-content-center'><Placeholder xs={8} /></Card.Header>
                                                <ListGroup variant="flush">
                                                    <ListGroup.Item className='text-nowrap'><Placeholder xs={8} /></ListGroup.Item>
                                                    <ListGroup.Item className='text-nowrap'><Placeholder xs={8} /></ListGroup.Item>
                                                </ListGroup>                        
                                            </Card>
                                        </Col>
                                        ))}                          
                                        <Col md="auto" className='d-flex flex-column justify-content-between'>
                                            <Button className='btn btn-info'><Placeholder xs={12} /></Button>
                                            <Button className='mt-3 btn btn-info'><Placeholder xs={12} /></Button> 
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                    </Row>
                    </Card.Body>
                </Card>
            ))}
            </React.Fragment>
        ) : (
            <React.Fragment>
            {programGroups.filter(pg => pg.pg_id === 1).map((pg,index)=>(
                <Card className='mb-4' key={index}>
                    <Card.Header className='text-center fs-3'>{appLanguage === 'hi' ? pg.pg_name_hi || pg.pg_name : pg.pg_name}</Card.Header>
                    <Card.Body>
                        <ProgramType pgId={pg.pg_id} />
                    </Card.Body>
                </Card>
            ))}
            </React.Fragment>
        )}
        </React.Fragment>        
    );
}
export default UndergraduateAdmission;

const ProgramType = ({pgId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[programType,setType]=useState([]);
    useEffect(()=>
    {
        const getProgramType = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"programsType/byProgramGroup/"+pgId);
                const result = await response.json();
                if( result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.pt_id + "/ptBrochure")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.pt_id + "/ptBrochureHi")
                                .then(upph => upph.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp,upph]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upph
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].ptBrochure = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].ptBrochureHi = (el.upph.length > 0) ? global.config.uploadPath + el.upph[0].up_fname + el.upph[0].up_ext : '';                            
                        });
                        setType(result);
                    }).catch(error => {
                        console.error('Program Type File :', error);
                    });
                }
                else
                {
                    setType([]);
                }
                if( global.config.IsPrint === true ) { console.info('Program Type : Result',result); }
              
            } catch (error) 
            {
                console.error('Program Type : Error', error.message);
            }
        };
        getProgramType();    
    },[pgId])
    return (
        <Row className='g-3'>
        {programType.map((pt,index)=>(
            <Col md="auto" key={index}>
                <Card className='text-bg-light border-primary'>
                    <Card.Header className='text-bg-primary border-primary text-center fs-5'>
                        {appLanguage === 'hi' ? (pt.pt_display_en === "1" ? pt.pt_name_hi || '' : pt.pt_name_hi || pt.pt_name) : pt.pt_name}    
                    </Card.Header>
                    <Card.Body>
                        <Row className='g-3'>
                            <Programs ptId={pt.pt_id} />                          
                            <Col md="auto" className='d-flex flex-column justify-content-between'>
                            {appLanguage === 'hi' ? 
                                (
                                    pt.pt_display_en === "1" && pt.ptBrochureHi 
                                    ? <a href={pt.ptBrochureHi} className='btn btn-info'>प्रवेश ब्रोशर<br />{cuurentNextYear()}</a> 
                                    : pt.ptBrochureHi 
                                        ? <a href={pt.ptBrochureHi} className='btn btn-info'>प्रवेश ब्रोशर<br />{cuurentNextYear()}</a> 
                                        : pt.ptBrochure
                                        ? <a href={pt.ptBrochure} className='btn btn-info'>प्रवेश ब्रोशर<br />{cuurentNextYear()}</a> 
                                        : ''
                                ) : (
                                    pt.ptBrochure 
                                    ? <a href={pt.ptBrochure} className='btn btn-info'>Admission Brochure<br />{cuurentNextYear()}</a> 
                                    : ''
                                )
                            }
                            { pt.pt_admission_link && <a href={pt.pt_admission_link} className='mt-3 btn btn-info' target='_blank' rel="noreferrer">
                                {appLanguage === 'hi' ? 'प्रवेश पोर्टल के लिए लिंक' : 'Link to Admission Portal'}<br />{cuurentNextYear()}
                            </a> } 
                            </Col>
                        </Row>
                        {pt.pt_admission_procedure !==null ? (
                            <div className='mt-3'>
                                <h5 className='border-bottom border-dark'>{appLanguage === 'hi' ? 'प्रवेश प्रक्रिया' : 'Admission Procedure'}</h5>
                                <div dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? (pt.pt_display_en === "1" ? pt.pt_admission_procedure_hi || '' : pt.pt_admission_procedure_hi || pt.pt_admission_procedure) : pt.pt_admission_procedure}} />
                            </div>
                        ) : null }
                    </Card.Body>
                </Card>
            </Col>
        ))}
        </Row>       
    );
}
const Programs = ({ptId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[programs,setPrograms]=useState([]);
    useEffect(()=>
    {
        const getPrograms = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"programs/programType/"+ptId);
                const result = await response.json();
                setPrograms(result);
                if( global.config.IsPrint === true ) { console.info('Programs : Result',result); }
              
            } catch (error) 
            {
                console.error('Programs : Error', error.message);
            }
        };
        getPrograms();    
    },[ptId])
    return (
        <React.Fragment>
        {programs.map((p,index)=>(
        <Col md="auto" key={index}>
            <Card className='text-center h-100'  style={{width:"13rem"}}>
                <Card.Header className='flex-grow-1 d-flex align-items-center justify-content-center fw-bold text-bg-info bg-info-subtle'>
                    {appLanguage === 'hi' ? (p.p_display_en === "1" ? p.p_name_hi || '' : p.p_name_hi || p.p_name) : p.p_name}
                </Card.Header>
                { p.p_intake > 0 && <ListGroup variant="flush">
                                        <ListGroup.Item className='text-nowrap'>{appLanguage === 'hi' ? 'समयांतराल:' : 'Duration:'} {p.p_duration} {appLanguage === 'hi' ? 'वर्ष' : 'Year'}</ListGroup.Item>
                                        <ListGroup.Item className='text-nowrap'>{appLanguage === 'hi' ? 'प्रवेश:' : 'Intake:'} {p.p_intake}</ListGroup.Item>
                                    </ListGroup>
                }
            </Card>
        </Col>
        ))}
        </React.Fragment>
    );
}